export const firebaseConfig = {
  apiKey: "AIzaSyApra4r-sIl85-fQZ8WXtnUIslatLaSR3A",
  authDomain: "girabatcom.firebaseapp.com",
  projectId: "girabatcom",
  storageBucket: "girabatcom.firebasestorage.app",
  messagingSenderId: "905327423598",
  appId: "1:905327423598:web:5b1596dc4f87fac6b0367f",
  measurementId: "G-WKL44R7JDN",
};

export const firebaseVapidKey = process.env.REACT_APP_FIREBASE_VAPID_KEY || "";
